/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { TemplateSelector } from "components/send-messages/template-selector";
import { TemplateForm } from "components/send-messages";
import { Viewer } from "components/auth/types";
import { Delta } from "components/message-editor/types";
import { calculateMessageValues } from "utils/template";
import {
  getTemplateGroup_templateGroup as Template,
  QueryInterestProfile_interest as InterestType,
} from "types/gql-types";
import { getLanguageNameByCode } from "../utils";
import styles from "./batchActions.module.css";

export interface SendMessageStateValues {
  emailEnabled: boolean;
  emailBody: Delta;
  emailSubject: string;
  emailBccAddress: string;
  emailRespondToEnabled: boolean;
  letterEnabled: boolean;
  letterBody: Delta;
  smsEnabled: boolean;
  smsBody: Delta;
  smsPropertyUseCaseId: string | null;
}


interface Props {
  interest: InterestType;
  interestListID: string;
  viewer: Viewer;
  onChange: (param: SendMessageStateValues) => void;
  isShowing: boolean;
  errorMsgEmail?: string;
  errorMsgSms?: string;
  errorMsgLetter?: string;
}

const MessageForm: React.FC<Props> = ({
  interest,
  interestListID,
  viewer,
  onChange,
  isShowing,
  errorMsgEmail,
  errorMsgSms,
  errorMsgLetter,
}) => {

  const [template, setTemplate] = React.useState<Template | null>(null);
  const updateValues = calculateMessageValues(template);

  let firstName = interest.applicantFirstName || interest.householdMember0FirstName;
  let lastName = interest.applicantLastName || interest.householdMember0LastName;
  if (!firstName && !lastName) {
    firstName = "N/A";
    lastName = "";
  }

  return (
    <>
      <Grid item xs={12} className={isShowing ? "" : styles.hideView}>
        <Typography variant="subtitle1">Send a Message to: 1 applicant</Typography>
        {interest.prefLang && interest.prefLang !== "en" && (
          <span className="badge hc-badge">
            {getLanguageNameByCode(interest.prefLang)}
          </span>
        )}
      </Grid>
      <TemplateSelector
        onChange={(selectedTemplate: Template | null) => {
          if (selectedTemplate) setTemplate(selectedTemplate);
        }}
        viewer={viewer}
        currentTemplate={template}
        className={isShowing ? "" : styles.hideView}
      />
      <hr className={isShowing ? "" : styles.hideView} />
      <Grid item xs={12} className={isShowing ? "" : styles.hideView}>
        <TemplateForm
          viewer={viewer}
          isSending={false}
          template={template}
          onRequestClose={() => setTemplate(null)}
          currentListId={interestListID}
          {...updateValues}
          isHidingSubmitBtns
          onChange={onChange}
          errorMsgEmail={errorMsgEmail}
          errorMsgSms={errorMsgSms}
          errorMsgLetter={errorMsgLetter}
        />
      </Grid>
    </>
  );
};
export default MessageForm;
